module.exports = __webpack_public_path__ + "img/logo1.f335b861.png";